import { render } from "./confirm.vue?vue&type=template&id=6365d073&ts=true"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__